/**
 * @ngdoc services
 * @memberof mercury.services
 * @name reactBridge
 * @description Service to expose some Angular services to React
 */
angular.module('mercury.startup')
.run(["$http", "$q", "$rootScope", "$window", "dialog", "logger", "settings", "userinfo", function reactBridge($http, $q, $rootScope, $window, dialog, logger, settings, userinfo) {

  logger.info('ReactBridge: Initializing...');

  /**
   * Helper to return data about the current app state that is expected to be
   * read by the React app.
   *
   * Note that this is intended to return the current data when it is called,
   * so if the React app needs newer info it can call it again.
   * @returns
   */
  function provideAppContext() {
    return userinfo.ready()
      .then(function() {
        return {
          userDetails: userinfo.userDetails(),
          activeCompany: userinfo.companies().find(function(company) { return company.id === userinfo.activeCompany(); }),
          allCompanies: userinfo.companies()
        };
      });
  }

  // Bind to a global object so React can access it
  $window.__Loaded = $window.__Loaded || {};
  Object.assign($window.__Loaded, {
    reactBridge: {
      appContext: provideAppContext
    }
  });

  var appContextSetEventName = '@@loaded/appContextSet';
  var appContextChangeEventName = '@@loaded/appContextChange';

  // We tell the react app when it's safe for it to start reading the shared
  // global object in order for it to access data set by AngularJS.
  userinfo.ready()
    .then(function() {
      $window.dispatchEvent(new CustomEvent(appContextSetEventName));
    });

  // When user info or company detail is changed we need to tell the React app
  // so that it can update it's view of the data.
  $rootScope.$on('userInfoUpdated', function() {
    $window.dispatchEvent(new CustomEvent(appContextChangeEventName, {detail: {type: 'user-info'}}));
  });
  $rootScope.$on('companyChanged', function() {
    $window.dispatchEvent(new CustomEvent(appContextChangeEventName, {detail: {type: 'company'}}));
  });

  // Allow the react app to open the support dialog
  //
  // Note this code is a copy with minor modifications of the feedback directive
  // in app/directives/feedback/feedback.directive.js
  $window.addEventListener('@@loaded/open-support-dialog', function() {
    var scope = $rootScope.$new();
    scope.feedbackReceived = false;
    scope.feedback = {
      email: userinfo.userDetails().email ? userinfo.userDetails().email : '',
      page: window.location.hash,
      description: '',
      subject: ''
    };
    scope.feedbackSubmit = function(formCtrl) {
      formCtrl.$setSubmitted();
      if (formCtrl.$invalid) {
        return;
      }

      scope.submitting = $http.post(settings.mercHost + '/zendesk', scope.feedback);
      scope.submitting.then(function() {
        scope.feedbackReceived = true;
      });
    };

    dialog.open({
      templateUrl: 'directives/feedback/feedback.tpl.html',
      scope: scope
    });
  });

}]);
